// extracted by mini-css-extract-plugin
export var table = "_wa-0";